import type { taskEither } from "fp-ts";

import type { GetMany, GetPaginated, MarkAsRead } from "./ios";

import type { AuthenticationError, NotFoundError, UnexpectedError } from "~/shared/error";

abstract class Provider {
  abstract markAsRead(
    params: MarkAsRead.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract markAllAsRead(): taskEither.TaskEither<UnexpectedError | AuthenticationError, void>;
  abstract getMany(): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetMany.Out>;
  abstract getPaginated(
    params: GetPaginated.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetPaginated.Out>;
}

export { Provider };
